import newRequest from '@/utils/new-request';

// 合同台账列表
export const apiContractGetPage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/page',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 删除合同台账
export const apiContractDelete = (id, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: `/contract/delete/${id}`,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 删除业务数据
export const apiContractDeleteBusiness = (id, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: `/contract/deleteBusiness/${id}`,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 文件作废
export const apiContractInvalid = (id, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: `/contract/invalid/${id}`,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 获取合同台账详情
export const apiContractGet = (id, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: `/contract/getDetail/${id}`,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 新增合同台账
export const apiContractAdd = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/add',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 修改合同台账
export const apiContractUpdate = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/edit',
    data,
    isLoading: isBool
  });
};

// 导出
export const apiContractExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/export',
    data,
    isLoading: isBool
  });
};

// 全量导出生效文件
export const apiContractExportAll = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/exportWithValidFiles',
    data,
    isLoading: isBool
  });
};

// 全量导出文件
export const apiContractExportAllInvalid = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/contract/exportWithFullFiles',
    data,
    isLoading: isBool
  });
};

// 操作日志
export const apiContractLogGetPage = (id, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: `/contract/getOperationLog/${id}`,
    isLoading: isBool
  });
};

// 可对账状态
export const apiContractGetReconciliationStatus = () => {
  return newRequest({
    method: 'get',
    url: '/contract/listReconciliationStatus',
    isLoading: false
  });
};

// 批量下载扫描件
export const apiContractBatchDownload = (id, isBool = false) => {
  return newRequest({
    method: 'get',
    url: `/contract/downloadFiles/${id}`,
    isLoading: isBool
  });
};
